import style from './style.module.css';

//Todo: remove any
const Grid = ({ children }: any) => {
  return <div className={style.Grid}>{children}</div>;
};

export default Grid;
